<template>
  <div class="section section-lg">
    <!-- <scale-loader
      v-if="charge === true"
      :color="loaderColor"
      class="text-center"
    /> -->
    <div class="text-center">
      <div class="myContainer">
        <img :src="imageSource" class="image" alt="" />
        <div class="overlay">
          <h3 style="color: beige; font-size: 50px; font-weight: bold;">
            {{ service.title }}<span v-if="show">(téléphone géant)</span>
          </h3>
        </div>
      </div>

      <div class="text-all descript">
        <p v-html="service.description"></p>
      </div>
    </div>
    <div
      class=""
      style="width: 100%; margin-top: 30px; display: flex; align-items: center; justify-content: center;"
    >
      <base-button class="btn-1" type="primary" @click="$router.push('contact')"
        >DEMANDER UN DEVIS</base-button
      >
    </div>
  </div>
</template>

<script>
import ScaleLoader from "vue-spinner/src/PulseLoader";
import galerie from "./myComponent/galerie.vue";
import mooving from "../../public/img/theme/movingboard_.jpeg";
import journal from "../../public/img/theme/celtiis/journal.jpeg";
import sandwich from "../../public/img/theme/woodin/velopub.jpg";
import vente from "../../public/img/theme/commercial.jpg";
import velo from "../../public/img/theme/velocover.jpg";
import telephone from "../../public/img/theme/telephone.jpg";
import quadra from "../../public/img/theme/quadra.jpg";

export default {
  name: "service",
  components: {
    ScaleLoader,
    galerie,
  },
  data: function() {
    return {
      charge: true,
      loaderColor: "#4da275",
      service: {},
      imageSource: "",
      show: false,
    };
  },
  mounted() {
    this.getService();
  },
  methods: {
    getService() {
      this.service = JSON.parse(localStorage.getItem("service"));
      if (this.service && this.service.imageSrc == "mooving")
        this.imageSource = mooving;
      if (this.service && this.service.imageSrc == "journal")
        this.imageSource = journal;
      if (this.service && this.service.imageSrc == "vente")
        this.imageSource = vente;
      if (this.service && this.service.imageSrc == "flash")
        this.imageSource = flashMob2;
      if (this.service && this.service.imageSrc == "sandwich")
        this.imageSource = sandwich;
      if (this.service && this.service.imageSrc == "velo")
        this.imageSource = velo;
      if (this.service && this.service.imageSrc == "telephone") {
        this.imageSource = telephone;
        this.show = true;
      }
      if (this.service && this.service.imageSrc == "quadra")
        this.imageSource = quadra;
    },
  },
};
</script>
<style scoped>
.image {
  width: 100%;
  height: 90svh;
  display: block;
}

@media screen and (max-width: 600px) {
  .image {
    float: none;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    width: 500px;
    height: 300px;
  }
}

.myContainer {
  position: relative;
}

.overlay {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  inset: 0px;
  background-color: rgb(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}

.text-all {
  margin: 50px 40px 0;
  text-align: justify;
}

@media screen and (min-width: 1440px) {
  .descript {
    margin-left: 150px;
    margin-right: 150px;
  }
}

@media screen and (min-width: 1536px) {
  .descript {
    margin-left: 200px;
    margin-right: 200px;
  }
}
</style>
